export const SERVER_ERROR = 'SERVER_ERROR';
export const GENERAL_ERROR = 'GENERAL_ERROR';
export const REQUEST_ERROR = 'REQUEST_ERROR';
export const AUTHENTICATION_INVALID = 'AUTHENTICATION_INVALID';
export const UNAUTHORIZED = 'UNAUTHORIZED';
export const SERVER_UNDERLYING_SYSTEM_ERROR = 'SERVER_UNDERLYING_SYSTEM_ERROR';
export const DB_TEMPORARILY_UNAVAILABLE = 'DB_TEMPORARILY_UNAVAILABLE';
export const NOT_FOUND = 'NOT_FOUND';
export const VALIDATION_VIOLATION = 'VALIDATION_VIOLATION';
